import jsonp from 'jsonp'
import Rsa from './encrypt'
import store from '../store'
const rsa = new Rsa()

export const convertStringToParam = string => {
  if (!string) {
    return {}
  }
  let stringArr = string.replace('?', '').split('&')
  let param = stringArr.reduce((obj, item) => {
    let result = item.split('=')
    obj[result[0]] = result[1]
    return obj
  }, {})
  return param
}

export const convertParamToString = params => {
  let paramArray = []
  for (let key in params) {
    let val = params[key]
    if (typeof val === 'object') {
      val = JSON.stringify(val)
    }
    let param = key + '=' + val
    paramArray.push(param)
  }
  paramArray.push('callback')
  if (paramArray.length > 0) {
    return paramArray.join('&')
  }
  return ''
}

export const convertObjToString = obj => {
  let paramArray = []
  for (let key in obj) {
    let val = obj[key]
    if (!val) {
      continue
    }
    if (typeof val === 'object') {
      val = JSON.stringify(val)
    }
    let param = key + '=' + val
    paramArray.push(param)
  }
  // paramArray.push('callback')
  if (paramArray.length > 0) {
    return '?' + paramArray.join('&')
  }
  return ''
}

export const getJSON = (action, params) => {
  action = /^http(s?):\/\/|^\/\//gi.test(action) ? action : `/api${action}`
  return new Promise((resolve, reject) => {
    let paramStr = convertParamToString(params || {})
    jsonp(
      action,
      {
        prefix: 'jsonpCallback',
        param: paramStr
      },
      (err, response) => {
        if (!err) {
          resolve(response)
        } else {
          reject(
            new Error({
              errmsg: '',
              data: response.data,
              res: response
            })
          )
        }
      }
    )
  })
}

let obj = {}
let eventsList = []
let operateTime = 0
let prevAction = 'init'
let sendImmediate = false
const loginAccount = window.UID
const oldPervAction = window.localStorage.getItem(loginAccount)
const immediateEvent = [
  '提交訂單',
  '提交訂單失敗',
  '提交訂單成功',
  '關閉窗口',
  '儲值失敗',
  '儲值成功',
  '可用折扣券-使用按钮',
  '赠送抵扣券-使用按钮'
]
const visitObj = JSON.parse(window.localStorage.getItem('visitObj') || '{}')
const visitTime = (visitObj[loginAccount] || 0) + 1
if (oldPervAction) {
  prevAction = oldPervAction
  window.localStorage.removeItem(loginAccount)
}
obj[loginAccount] = visitTime
window.localStorage.setItem(
  'visitObj',
  JSON.stringify({ ...visitObj, ...obj })
)

const serializeData = data => {
  let dataStr = ''
  for (let fieldName in data) {
    dataStr += '&' + fieldName + '=' + data[fieldName]
  }
  return dataStr
}

const sendDatain = data => {
  const baseUrl =
        'https://datain.octlib.com/api/v1/hw/common/event/collect?apikey=72e0e1c0-51e3-45ab-9b36-bf3b82143d9d&id=2'
  const extraUrl = serializeData(data)
  // getJSON(baseUrl + extraUrl)
  let image = document.createElement('img')
  image.src = baseUrl + extraUrl
  document.body.appendChild(image)
  document.body.removeChild(image)
  image = null
}

const judgePlate = function () {
  var n = window.navigator.userAgent.toLowerCase()
  let device = {
    isAndroid: function () {
      return n.indexOf('android') > -1
    },
    isIOS: function () {
      return n.indexOf('iphone') > -1
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i)
    },
    isIpad: function () {
      var n = navigator.platform
      return (
        /iPad/gi.test(n) ||
                (n === 'MacIntel' &&
                    navigator.maxTouchPoints > 1 &&
                    !window.MSStream)
      )
    },
    isPhone: function () {
      return (
        this.isAndroid() ||
                this.isIOS() ||
                this.isWinPhone() ||
                this.isIpad()
      )
    }
  }
  let str = device.isPhone()
    ? device.isIOS() || device.isIpad()
      ? 'ios'
      : device.isAndroid
        ? 'android'
        : 'unknow'
    : 'pc'
  return str
}

const devicePlate = judgePlate()

export const datain = payload => {
  let userInfo = store.getters.getUserInfo
  if (immediateEvent.indexOf(payload.ext3) !== -1) {
    sendImmediate = true
  }
  payload = {
    event: 'click',
    gameID: getHrefParamFromLocation('gameId') || userInfo.game_id,
    phoneModel: getHrefParamFromLocation('devicePlate') || devicePlate,
    loginAccount:
            window.loginAccount ||
            getHrefParamFromLocation('loginAccount') ||
            userInfo.account_name ||
            userInfo.LOGIN_ACCOUNT ||
            '',
    deviceCode: getHrefParamFromLocation('customUserId'),
    gameServerID:
            getHrefParamFromLocation('serverId') || userInfo.server_id,
    ext1: encodeURIComponent(store.getters.getFromPage),
    ext2: encodeURIComponent(window.location.href),
    ext6: visitTime,
    ext7: `${visitTime}-${operateTime++}`,
    ext8: window.UID,
    ext9: store.getters.getPageName,
    ext12: prevAction,
    ext13: getHrefParamFromLocation('cid') || '',
    ext14: getHrefParamFromLocation('scid') || '',
    ...payload
  }
  eventsList.push(payload)
  prevAction = payload.ext3
  if (sendImmediate || payload.event === 'load') {
    eventsList = eventsList.filter(item => !item.isSend)
    if (payload.resetAllEvent) {
      eventsList = eventsList.map(item => {
        return {
          ...item,
          ext4: payload.ext4,
          ext5: payload.ext5,
          ext10: payload.ext10,
          ext11: item.ext3 === '選擇金額' ? item.ext11 : payload.ext11
        }
      })
    }
    eventsList.forEach(item => {
      sendDatain(item)
      item.isSend = true
    })
    sendImmediate = false
  }
}

export const isEmptyObj = obj => {
  return Object.keys(obj).length === 0
}

export const encryption = text => {
  return rsa.encode(text)
}

export const getHrefParamFromLocation = (
  paramName,
  newHref,
  needDecode = true
) => {
  let paramsStr = window.location.search
  let hashIndex = window.location.hash.indexOf('?')
  if (hashIndex > -1) {
    paramsStr += window.location.hash.substr(hashIndex).replace('?', '&')
  }
  let href =
        newHref || needDecode
          ? decodeURIComponent(paramsStr).substr(1)
          : paramsStr.substr(1)
  let reg = new RegExp('(^|&|\\?)' + paramName + '=([^&]*)(&|$)')
  let matchResult = href.match(reg)
  let param = matchResult ? decodeURIComponent(matchResult[2]) : ''
  return param
}

export const formatDate = (date, fmt) => {
  if (Object.prototype.toString.apply(date) !== '[object Date]') {
    try {
      date = new Date(date)
    } catch {
      return 'Invalid Date'
    }
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      )
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

function Base64 () {
  // private property
  let _keyStr =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='

  // public method for encoding
  this.encode = function (input) {
    let output = ''
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4
    let i = 0
    input = this._utf8_encode(input)
    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output =
                output +
                _keyStr.charAt(enc1) +
                _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) +
                _keyStr.charAt(enc4)
    }
    return output
  }

  // public method for decoding
  this.decode = function (input) {
    let output = ''
    let chr1, chr2, chr3
    let enc1, enc2, enc3, enc4
    let i = 0
    input = input.replace(/[^A-Za-z0-9+/=]/g, '')
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++))
      enc2 = _keyStr.indexOf(input.charAt(i++))
      enc3 = _keyStr.indexOf(input.charAt(i++))
      enc4 = _keyStr.indexOf(input.charAt(i++))
      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4
      output = output + String.fromCharCode(chr1)
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3)
      }
    }
    output = this._utf8_decode(output)
    return output
  }

  // private method for UTF-8 encoding
  this._utf8_encode = function (string) {
    string = string.replace(/\r\n/g, '\n')
    let utftext = ''
    for (let n = 0; n < string.length; n++) {
      let c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }

  // private method for UTF-8 decoding
  this._utf8_decode = function (utftext) {
    let string = ''
    let i = 0
    let c = 0
    let c2 = 0
    let c3 = 0
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        )
        i += 3
      }
    }
    return string
  }
}

export const base64 = new Base64()
